import AppointmentButton from '../../appointments/AppointmentButton';
import OrderAgreementProofs from '../../documents/OrderAgreementProofs';
import { useState } from "react";

import { useDispatch } from "react-redux";


import {
  updatePriestSelection
} from "../../../store/checkoutSlice";

const PriestCard = ({ item, eventId, isCheckout, isOrders }) => {

  const dispatch = useDispatch();

  const [selectedPct, setSelectedPct] = useState(100);

  const pricing = item.pricing || {};
  const priest = item.priest || {};

  const hasDiscount =
    pricing.discountPrice &&
    pricing.discountValidUpto &&
    new Date(pricing.discountValidUpto) > new Date();

  const handleToggle = (value) => {
    if (selectedPct === value) {
      if (!window.confirm("Remove item and order later?")) return;
      setSelectedPct(null);
    } else {
      setSelectedPct(value);
    }

    // 👉 connect redux here
    dispatch(updatePriestSelection({ eventId, percentage: value }))
  };

  return (
    <div className="card">
      {isOrders && <OrderAgreementProofs serviceType="priest" cartItemId={item.id} eventId={eventId} providerId={priest.id} />}
      <AppointmentButton providerId={priest.id || item.provider_id} providerName={priest.firstName || priest.first_name} eventId={eventId} source="event-provider" />

      {/* HEADER */}
      <div className="header">
        <h4>{priest.name}</h4>

        {!isOrders && !item.is_checked_out && item.paid_amount === 0 && (
          <button
            onClick={() => {
              if (!window.confirm("Remove this priest?")) return;
              dispatch(updatePriestSelection({ eventId, percentage: null }))
            }}
          >
            ❌
          </button>
        )}
      </div>

      {/* PACKAGE */}
      {item.isPackage && (
        <div className="package-box">
          <p>{item.packageDetails?.packageName}</p>
        </div>
      )}

      {/* AMOUNT SELECTION */}
      {isCheckout && (
        <div>
          <p>Choose Amount:</p>

          <label>
            <input
              type="radio"
              checked={selectedPct === 100}
              onChange={() => handleToggle(100)}
            />
            Full
          </label>

          <label>
            <input
              type="radio"
              checked={selectedPct === 25}
              onChange={() => handleToggle(25)}
            />
            25%
          </label>

          <label>
            <input
              type="radio"
              checked={selectedPct === 10}
              onChange={() => handleToggle(10)}
            />
            10%
          </label>
        </div>
      )}

      <hr />

      {/* PRICE */}
      {hasDiscount ? (
        <>
          <p style={{ textDecoration: "line-through" }}>
            ₹{pricing.price}
          </p>
          <p>₹{pricing.discountPrice}</p>
          <small>
            Valid till {new Date(pricing.discountValidUpto).toDateString()}
          </small>
        </>
      ) : (
        <p>Total: ₹{pricing.price}</p>
      )}

      <p>GST: ₹{pricing.gstAmount} ({pricing.gstPercentage}%)</p>

      <hr />

      <p><b>Sub Total: ₹{pricing.totalAmount}</b></p>

      {/* PAID */}
      {item.paid_amount > 0 && (
        <div style={{ color: "green" }}>
          Paid ₹{item.paid_amount}
        </div>
      )}

      {/* STATUS */}
      {isCheckout && (
        <p>
          {isOrders
            ? item.balance_to_be_paid > 0
              ? `Pending ₹${item.balance_to_be_paid}`
              : "Fully Paid"
            : selectedPct !== null
            ? `To Pay: ₹${item.paymentSummary?.payable_now || 0}`
            : "Order Later"}
        </p>
      )}
    </div>
  );
};

export default PriestCard;
